import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Document, Page, pdfjs } from "react-pdf";

import { useStyles } from "./PDFReader.css";
import PDFControlPanel from "./PDFControlPanel";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class PDFReader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scale: 1.0,
      numPages: null,
      pageNumber: 1,
    };
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({
      numPages,
    });
  };

  handlePageNumber = (pageNumber) => {
    if (pageNumber <= 1) {
      this.setState({ pageNumber: 1 });
    } else if (pageNumber >= this.state.numPages) {
      this.setState({ pageNumber: this.state.numPages });
    } else {
      this.setState({ pageNumber });
    }
  };

  handleScale = (scale) => {
    if (scale <= 0.5) {
      this.setState({ scale: 0.5 });
    } else if (scale >= 2.0) {
      this.setState({ scale: 2.0 });
    } else {
      this.setState({ scale });
    }
  };

  handlePageNumber = (number) => {
    if (!number) {
      this.setState({ pageNumber: 1 });
    }
    this.setState({ pageNumber: parseInt(number) });
  };

  handleError = () => {
    console.clear();
  };

  render() {
    const { scale, numPages, pageNumber } = this.state;
    const { classes, fileUrl, title } = this.props;
    return (
      <div className={classes.root}>
        <PDFControlPanel
          fileUrl={fileUrl}
          scale={scale}
          handleScale={this.handleScale}
          handlePageNumber={this.handlePageNumber}
          pageNumber={pageNumber}
          totalPages={numPages}
          title={title}
          handleCancelPdfStatus={this.props.handleCancelPdfStatus}
        />
        <div className={classes.body}>
          <br />
          <Document file={fileUrl} onLoadSuccess={this.onDocumentLoadSuccess}>
            <Page
              pageNumber={pageNumber}
              scale={scale}
              onLoadError={() => console.clear()}
              error={<div>The Page doesnot exist</div>}
            />
          </Document>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(PDFReader);
